import stickybits from 'ui-core/plugins/stickybits/js/stickybits.es';

(function ($, UX) {
    const sticky = {
        stickyNodes: [],
        stickyTargets:
            '.header, .issue-navigator, .navbar, .article__aside, .article__navbar, .table-of-content__nav, .tos-list',
        init() {
            this.stickyNodes = document.querySelectorAll(this.stickyTargets);
            this.setHeaderHeight();
            this.setSticky();
        },
        setHeaderHeight() {
            // set the initial value of --header-height to override the default values
            $('body')
                .get(0)
                .style.setProperty('--header-height', $('.header').innerHeight() + 'px');

            // to cover the case when resize from smaller screens to web and page reload
            $(window).resize(function () {
                // On resize
                $('body')
                    .get(0)
                    .style.setProperty('--header-height', $('.header').innerHeight() + 'px');
            });
            // cover case when jump from Simulater viewport into web and on page reload
            $(document).on('smartResize', function () {
                $('body')
                    .get(0)
                    .style.setProperty('--header-height', $('.header').innerHeight() + 'px');
            });
        },
        setSticky() {
            if (!UX.test.isIE() || UX.test.isIE() > 11) {
                return;
            }
            stickybits(`${this.stickyTargets}, .article__navbar__secondary`, {useStickyClasses: true});
            this.stickyNodes.forEach(function (node) {
                const nodeWinOffset = node.getBoundingClientRect();
                node.style.left = nodeWinOffset.left + 'px';
                node.style.width = nodeWinOffset.width + 'px';
                node.style.right = window.outerWidth - nodeWinOffset.right + 'px';
            });
        },
    };

    $(() => {
        sticky.init();
    });
})(jQuery, UX);
